import { useQuery } from '@tanstack/react-query';

import { fetchPromoDetails } from '../api';

export const QUERY_KEY_DISCOUNT_DETAILS = 'discount-details';

export function usePromoDetailsQuery({ promoKey }: { promoKey: string }) {
    const key = promoKey.trim();

    return useQuery({
        queryKey: [QUERY_KEY_DISCOUNT_DETAILS, key],
        queryFn: () => fetchPromoDetails({ promoKey: key }),
        staleTime: 60 * 60 * 1000, // 1hr
        enabled: Boolean(key),
    });
}
